// Thunk rejections reach the screen as { message } (RTK miniSerializeError), not as the raw string
export const loginErrorMessage = (error, t) => {
  const code = typeof error === 'string' ? error : error?.message;
  if (code === 'Unauthorized') return t('invalid');
  if (code === 'DEVICE_LOGIN_BLOCKED') return t('deviceLoginBlocked');
  return code || t('invalid');
};
